import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/venta-equipos.css';

const VentaEquipos = () => {
  const servicios = [
    {
      icon: 'computer',
      title: 'Computadores y Laptops',
      description: 'Equipos de última generación',
      details: 'Ofrecemos una amplia gama de computadores y laptops de las mejores marcas.',
      highlight: 'Garantía extendida incluida',
      tagline: 'Potencia tu trabajo'
    },
    {
      icon: 'keyboard',
      title: 'Periféricos y Accesorios',
      description: 'Todo lo que necesitas',
      details: 'Teclados, mouse, monitores y más accesorios de alta calidad.',
      highlight: 'Envío gratis en compras superiores',
      tagline: 'Mejora tu setup'
    },
    {
      icon: 'security',
      title: 'Cámaras de Seguridad',
      description: 'Sistemas de vigilancia HD',
      details: 'Cámaras con visión nocturna y detección de movimiento.',
      highlight: 'Instalación profesional incluida',
      tagline: 'Protege lo importante'
    },
    {
      icon: 'code',
      title: 'Licencias de Software',
      description: 'Software original',
      details: 'Licencias oficiales de Windows, Office y antivirus.',
      highlight: 'Descuentos para empresas',
      tagline: 'Trabaja con software legal'
    }
  ];

  return (
    <div className="venta-equipos-container">
      <div className="venta-equipos-header">
        <h1>Venta de Equipos</h1>
        <p>Encuentra los mejores equipos para tu negocio</p>
      </div>

      <div className="venta-equipos-grid">
        {servicios.map((servicio, index) => (
          <div key={index} className="venta-equipos-card">
            <div className="card-icon">
              <span className="material-icons">{servicio.icon}</span>
            </div>
            <div className="card-content">
              <h3>{servicio.title}</h3>
              <p className="card-description">{servicio.description}</p>
              <p className="card-details">{servicio.details}</p>
              <p className="card-highlight">{servicio.highlight}</p>
              <p className="card-tagline">{servicio.tagline}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="venta-equipos-contacto">
        <h2>¿Necesitas asesoría?</h2>
        <div className="contacto-info">
          <a href="tel:+573112610669" className="info-item">
            <span className="material-icons">phone</span>
            <p>+57 3112610669</p>
          </a>
          <a href="https://wa.me/573112610669" target="_blank" rel="noopener noreferrer" className="info-item">
            <span className="material-icons">whatsapp</span>
            <p>+57 3112610669</p>
          </a>
          <div className="info-item">
            <span className="material-icons">schedule</span>
            <p>Lun - Vie: 8am - 6pm</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VentaEquipos; 